import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { OwsClientService, OwsServiceErrorResponse } from 'ows-library';
import { AuthorizationServicesEnum } from 'ows-library';
import { PopUpService } from 'app/compartilhado/componentes/pop-up/pop-up.service';
import { NotaFiscalModel } from './Models/NotaFiscalModel';

@Injectable()
export class NfsePayloadService {

  notaFiscalModel: NotaFiscalModel = new NotaFiscalModel();
  notaFiscalPayloadChanged = new Subject<NotaFiscalModel>();
  url: string

  constructor(private owsClientService: OwsClientService,
    private popUpService: PopUpService) {
  }

  obterNfseById(notaFiscalId: string) {
    this.owsClientService.get<any>('administrativo/nfse/payload', {
      authorizationService: AuthorizationServicesEnum.None,
      requestParameters: [{ key: 'notaFiscalId', value: notaFiscalId }]
    }).subscribe((response) => {
      this.notaFiscalModel = response.body;
      this.notaFiscalPayloadChanged.next(this.notaFiscalModel);
    },
      error => {
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else if (!error.error) {
          this.popUpService.showCustomPopWarning('Falha na operação do registro.', 'Não foi possível estabelecer conexão com a API.')
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
      });
  }

  obterPdfNfse(nfsePdfStorageId: string, nfsePdfArquivoNome: string) {
    this.owsClientService.get<any>('administrativo/nfse/payload/pdfurl', {
      authorizationService: AuthorizationServicesEnum.None,
      requestParameters: [{ key: 'nfsePdfStorageId', value: nfsePdfStorageId },
      { key: 'nfsePdfArquivoNome', value: nfsePdfArquivoNome }]
    }).subscribe((response) => {
      if (response.body && response.body.url) {
        document.location.href = response.body.url;
      }
    },
      error => {
        if (error instanceof Error) {
          this.popUpService.showCustomPopWarning('Erro de conexão', error.message);
        } else if (!error.error) {
          this.popUpService.showCustomPopWarning('Falha na operação do registro.', 'Não foi possível estabelecer conexão com a API.')
        } else {
          this.popUpService.showCustomPopWarning('Falha na operação do registro', (<OwsServiceErrorResponse>error).error.Code + ': ' + (<OwsServiceErrorResponse>error).error.Message);
        }
      });
  }
}
